import $ from 'jquery';
import showFlash from 'legacy/javascripts/alerts.js';

$(function () {
  let otpSent = false;
  const $submit = $('.js-login-submit');
  const $loginGroup = $('.js-login-group');
  const $login = $('.js-login');
  const $passwordGroup = $('.js-password-group');
  const $password = $('.js-password');
  const $otpEnabled = $('.js-otp-enabled');

  if (!$otpEnabled.length) {
    return
  }
  let timerInterval = null; // Store the interval so we can clear it

  function startCountdown(expiresAtTimestamp) {
    if (timerInterval) {
      clearInterval(timerInterval);
    }
    const $timerContainer = $('#countdown-timer');
    const $timerDisplay = $('#time-left');
    $timerContainer.removeClass('hidden');
    // Convert to milliseconds
    const expirationTime = expiresAtTimestamp * 1000;
    timerInterval = setInterval(function () {
      const now = new Date().getTime();
      const distance = expirationTime - now;
      if (distance > 0) {
        const minutes = Math.floor(distance / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
        $timerDisplay.text(minutes + ":" + formattedSeconds);
        $timerContainer.show();
        $timerDisplay.text(secondsLeft);
      } else {
        // Time has expired
        clearInterval(timerInterval);
        $timerContainer.text("Code expired. Please request a new one.");
        $timerContainer.show(); // Ensure it's visible to show the expired message
      }

    }, 1000);
  }

  $submit.on('click', function (e) {
    if (!otpSent) {
      e.preventDefault();
      $.ajax({
        url: `${window.location.protocol}//${window.location.host}/employees/otp`,
        type: 'POST',
        data: {
          login: $login.val(),
          password: $password.val()
        },
        dataType: 'json',
        success: function (data) {
          otpSent = true;
          const expiresAt = data.expires_at;
          $passwordGroup.addClass('hidden');
          $loginGroup.addClass('hidden');
          $otpEnabled.removeClass('hidden');
          showFlash('success', 'Please enter the one time code sent to your email.')
          startCountdown(expiresAt);
        },
        error: function (xhr, status, error) {
          const message = xhr.responseJSON?.error || error
          showFlash('error', message)
        }
      })
    }
  });
});
